import React from 'react';
import { createIntl, FormattedMessage } from 'react-intl';
import { getLocale } from '../../../store/cache/locales';
import { translations } from '../../Intl';
export var t = function (key, values, defaultMessage) {
    if (values === void 0) { values = {}; }
    if (defaultMessage === void 0) { defaultMessage = ''; }
    return (React.createElement(FormattedMessage, { defaultMessage: defaultMessage, id: key, values: values }));
};
export var translate = function (key) {
    if (!key) {
        return '';
    }
    var locale = getLocale();
    var intl = createIntl({
        locale: locale,
        messages: translations[locale],
        onError: function (f) { return f; },
    });
    return intl.formatMessage({ id: key });
};
export var getKeyTranslations = function (key) {
    if (!key) {
        throw new Error("Missing key");
    }
    var language = Object.keys(translations);
    var keyTranslations = {};
    language.forEach(function (element) {
        keyTranslations[element] = translations[element][key];
    });
    return keyTranslations;
};
export var flatLocale = function (locale, path, data) {
    if (path === void 0) { path = []; }
    if (data === void 0) { data = {}; }
    Object.entries(locale).forEach(function (entry) {
        var key = entry[0], value = entry[1];
        if (typeof value === 'object') {
            flatLocale(value, path.concat(key), data);
        }
        else {
            data[path.concat(key).join('.')] = value;
        }
    });
    return data;
};
export var flatTranslations = function (translations) {
    var translationData = { en: null };
    Object.entries(translations).forEach(function (entry) {
        var key = entry[0], value = entry[1];
        translationData[key] = flatLocale(value);
    });
    return translationData;
};
